import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { type Observable, of } from 'rxjs';

@Component({
  selector: 'bd-highcharts-toolbar',
  imports: [AsyncPipe, ButtonModule],
  templateUrl: './highcharts-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HighchartsToolbarComponent {
  @Input() contentOverviewState: Observable<'hide' | 'show'> = of('hide');
  @Input() onContentOverviewStateChange: (state: 'show' | 'hide') => void =
    () => {};

  onContentOverviewToggleClicked(currentState: 'hide' | 'show'): void {
    this.onContentOverviewStateChange(
      currentState === 'show' ? 'hide' : 'show',
    );
  }
}
